<template>
    <div class="zyjj_h5">
      <TopTabs :list="this.$nav6"/>
      <div class="zsxx_bottom_h5">
        <h5 class="title">{{obj.name}}</h5>
        <div class="content" v-html="obj.intro"></div>
      </div>
    </div>
</template>

<script>
import TopTabs from '@/components/topTabs_h5/index'
export default {
  name: 'Zyjj',
  components: { TopTabs },
  props: {},
  data () {
    return {
      obj: {}
    }
  },
  computed: {},
  watch: {},
  created () {
    this.getDepartment()
  },
  mounted () {},
  methods: {
    async getDepartment () {
      const data = await this.$get('/ow/major/' + this.$route.query.id)
      this.obj = data
      console.log(data)
    }
  }
}
</script>

<style lang="scss" scoped>
  .zyjj_h5 {
    font-size: 3.7333vw;
    color: #333333;
    .zsxx_bottom_h5 {
      padding: 0 4.2667vw;
      min-height: 180vw;
    }
      .title {
        font-size: 4vw;
        margin-bottom: 6vw;

      }
      .content{
        font-size: 3.7333vw;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        ::v-deep p {
          line-height: 2 !important;
        }
        ::v-deep img {
          display: block;
          margin: 0 auto;
          max-width: 100%!important;
          height: auto!important;
        }
      }
    }
</style>
